import { computeMpmAvailableMpFromOccupancy } from "@/features/hoverIdle/mpm/mpmCapacity";
import type {
  MpmHovGridUnlockState,
  MpmState,
} from "@/features/hoverIdle/mpm/mpmState";

export interface MpmHovTargetSlot {
  readonly index: number;
  readonly label: string;
  readonly assigned: boolean;
  readonly disabled: boolean;
}

export interface MpmHovTargetSlotInput {
  readonly mpCapacity: number;
  readonly mpm: MpmState;
}

export const MPM_HOV_TARGET_BASE_SLOT_COUNT = 4;
export const MPM_HOV_TARGET_EXPANDED_SLOT_COUNT = 9;

export function createMpmHovTargetSlots(
  input: MpmHovTargetSlotInput,
): readonly MpmHovTargetSlot[] {
  if (!input.mpm.hovTargets.unlocked) {
    return [];
  }
  const slotCount = resolveMpmHovTargetSlotCount(input.mpm.gridUnlock.hov);
  const assignedIndices = new Set(input.mpm.hovTargets.assignments);
  const availableMp = computeMpmAvailableMpFromOccupancy({
    mpCapacity: input.mpCapacity,
    state: input.mpm,
  });
  const canAssign = input.mpm.hovTargets.enabled && availableMp > 0;

  return Array.from({ length: slotCount }, (_, index) => {
    const assigned = assignedIndices.has(index);
    return {
      index,
      label: `H${index + 1}`,
      assigned,
      disabled: !assigned && !canAssign,
    };
  });
}

export function resolveMpmHovTargetSlotCount(
  gridUnlock: MpmHovGridUnlockState,
): number {
  return gridUnlock.gridIncrease2
    ? MPM_HOV_TARGET_EXPANDED_SLOT_COUNT
    : MPM_HOV_TARGET_BASE_SLOT_COUNT;
}
